/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Swal from "sweetalert2";
import joinTeamData from "../data/joinTeamData";

export default function JoinOurTeam() {
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [formData, setFormData] = useState({
    full_name: "",          // بدلاً من name
    email: "",
    country: "",
    governorate_emirate: "",
    phone_number: "",
    experience: "",
    position: "",
    cv_path: null,          // بدلاً من cv
  });



  const showData = joinTeamData.map((el, index) => {
    return (
      <div
        key={index}
        className="bg-[#3896BE]/32 backdrop-blur-md rounded-lg p-5 shadow-md text-white h-[200px] flex justify-center flex-col items-center text-center"
      >
        <div className="text-lg font-semibold mb-2">{el.title}</div>
        <p className="text-sm leading-relaxed">{el.details}</p>
      </div>
    );
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, cv_path: e.target.files[0] }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key]) data.append(key, formData[key]);
    });

    try {
      const response = await axios.post(
        "https://ma-laravel.ma-uae.com/api/form-submissions",
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      Swal.fire({
        title: t("Success"),
        text: t("Submission created successfully"),
        icon: "success",
        confirmButtonText: t("OK"),
        confirmButtonColor: "#3896BE",
      });
      setIsPopupOpen(false);
      setFormData({
        full_name: "",
        email: "",
        country: "",
        governorate_emirate: "",
        phone_number: "",
        experience: "",
        position: "",
        cv: null,
      });
    } catch (error) {
      const errorMessage = error.response?.data?.errors
        ? Object.values(error.response.data.errors).flat().join(", ")
        : t("An error occurred while submitting the form");
      Swal.fire({
        title: t("Error"),
        text: errorMessage,
        icon: "error",
        confirmButtonText: t("OK"),
        confirmButtonColor: "#3896BE",
      });
    }
  };

  return (
    <section className="join-our-team relative pt-[40px]">
      <div className="container h-full relative z-10 text-white flex flex-col items-center justify-center gap-[20px]">
        <div className="flex flex-col items-center justify-center gap-[6px]">
          <div className="flex flex-col items-center justify-center gap-[8px] text-center mb-12">
            <h2 className="text-[35px] font-bold text-white">
              {t("Join Our Team")}
            </h2>
            <p className="text-lg text-white mx-auto max-w-[800px]">
              {t(
                "Are you passionate about accounting, finance, and helping businesses succeed? We're always looking for talented individuals to join our growing team."
              )}
            </p>
          </div>
        </div>

        <div className="f-col flex items-center justify-center gap-5">{showData}</div>

        <button
          onClick={() => setIsPopupOpen(true)}
          className="mb-2 w-fit mx-auto py-[7px] px-[30px] text-white rounded-[4px] bg-[#3896BE] hover:bg-[#2a7a9b] transition-colors duration-300"
        >
          {t("Send Your CV")}
        </button>
      </div>

      {/* Popup Form */}
      {isPopupOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
          <div className="custom-container">
            <h3 className="text-2xl font-bold text-[#3896BE] mb-6 text-center">
              {t("Job Application Form")}
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Full Name")}
                </label>
                <input
                  type="text"
                  name="full_name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border-[#3896BE] shadow-sm sm:text-sm p-2"
                  placeholder={t("Enter your full name")}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Email Address")}
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border-[#3896BE] shadow-sm sm:text-sm p-2"
                  placeholder={t("Enter your email")}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Country")}
                </label>
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border-[#3896BE] shadow-sm sm:text-sm p-2"
                  placeholder={t("Enter your country")}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Governorate/Emirate")}
                </label>
                <input
                  type="text"
                  name="governorate_emirate"
                  value={formData.governorate_emirate}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border-[#3896BE] shadow-sm sm:text-sm p-2"
                  placeholder={t("Enter your governorate or emirate")}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Phone Number")}
                </label>
                <input
                  type="tel"
                  name="phone_number"
                  value={formData.phone_number}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border-[#3896BE] shadow-sm sm:text-sm p-2"
                  placeholder={t("Enter your phone number")}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Experience")}
                </label>
                <textarea
                  name="experience"
                  value={formData.experience}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border-[#3896BE] shadow-sm sm:text-sm p-2"
                  placeholder={t("Describe your experience")}
                  rows="4"
                ></textarea>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Position")}
                </label>
                <input
                  type="text"
                  name="position"
                  value={formData.position}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border-[#3896BE] shadow-sm sm:text-sm p-2"
                  placeholder={t("Enter the position you're applying for")}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Upload CV (PDF)")}
                </label>
                <input
                  type="file"
                  name="cv_path"
                  onChange={handleFileChange}
                  accept="application/pdf"
                  required
                  className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#3896BE] file:text-white hover:file:bg-[#2a7a9b]"
                />
              </div>
              <div className="f-col flex justify-end gap-4">
                <button
                  type="button"
                  onClick={() => setIsPopupOpen(false)}
                  className="w-100 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors duration-300"
                >
                  {t("Cancel")}
                </button>
                <button
                  type="submit"
                  className="w-100 py-2 px-4 bg-[#3896BE] text-white rounded-md hover:bg-[#2a7a9b] transition-colors duration-300"
                >
                  {t("Submit")}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}
